import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { usePaletteColor } from '../theme';
export const Icon = React.forwardRef((props, ref) => {
    const { color: colorProp = 'action.active', iconComponent, outlineComponent, roundedComponent, filled, sx, width, height, ...muiProps } = props;
    const InnerIcon = filled ? iconComponent : outlineComponent;
    const color = usePaletteColor(colorProp);
    return (_jsx(InnerIcon, { ref: ref, "data-role": "icon", ...(color !== undefined ? { fill: color } : {}), sx: {
            ...(color !== undefined ? { color } : {}),
            borderRadius: '50%',
            overflow: 'visible !important',
            width,
            height,
            ...sx
        }, ...muiProps }));
});
